export default {
  name: "table-detail-modal",
  props: ['visible', 'title', 'data', 'columns'],
  computed: {
    modalVisible: {
      get: function get(vm) {
        if (typeof vm.visible === 'boolean') {
          return vm.visible;
        }
        return false;
      },
      set: function set(newValue) {
        this.$emit("update:visible", newValue);
      }
    },
    tableData: function tableData(vm) {
      if (vm.data) {
        return [vm.data];
      }
      return [];
    },
    tableColumns: function tableColumns(vm) {
      if (Array.isArray(vm.columns)) {
        return vm.columns;
      }
      return [];
    }
  },
  methods: {
    h: function h(tag, val) {
      return val;
    }
  }
};